import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ControlUtils } from '../utils/controlUtils';

/**
 * Methods for common use across the app
 */
@Injectable({
  providedIn: 'root'
})
export class CommonHelperService {
  private defaultCountryCode = 'AU';
  public currentCountryCode = new BehaviorSubject(this.defaultCountryCode);

  constructor(private http: HttpClient, private controlUtils: ControlUtils) {
    this.initCurrentCountryCode();
  }

  /**
   * Look for user country code automatically by current IP
   */
  private initCurrentCountryCode() {
    this.http.get<any>('https://api.ipbase.com/v1/json/').subscribe(resp => {
      const countryCode = (resp && resp.country_code) ? resp.country_code : this.defaultCountryCode;
      this.currentCountryCode.next(countryCode);
    }, () => this.currentCountryCode.next(this.defaultCountryCode));
  }

  /**
   * Stop any loading indicator that overlay the screen
   * @param event triggered event object from UI
   */
  async stopLoadingIndicator(event?) {
    if (event) {
      event.target.complete();
    }
    await this.controlUtils.stopPresentLoading();
  }
}
